//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from "vue-multiselect";
export default {
  name: "MatrixPicklist",
  props: ["value", "header"],
  components: {
    matrixPicklist: Multiselect
  },
  data() {
    return {
      selections: []
    };
  },
  computed: {
    options() {
      return this.header._picklist.items.map(item => {
        return { key: item.key, value: item.value };
      });
    }
  },
  methods: {
    tag(value) {
      const option = {
        key: value.trim(),
        value: value.trim()
      };
      this.selections.push(option);
    }
  },
  watch: {
    selections() {
      this.$emit("input", this.selections);
    }
  },
  created() {
    this.selections = this.value || [];
  }
};
